import { IDeviceConfigurationDictionary } from 'src/device-status/interfaces/IDeviceConfigurationDictionary';
export interface ITouchPointConfiguration {
  touchPointId?: string;
  touchPointApplicationId?: string;
  storeId?: string;
  accountExternalId?: string;
  manualTouchPointType?: string;
  isSaleTransactionBeginWithCustomerIdentification?: boolean;
  displayOnlyItemsInVariety?: boolean;
  alternateIdMinLength?: number;
  alternateIdMaxLength?: number;
  alternateIdSellingEngineMinLength?: number;
  alternateIdSellingEngineMaxLength?: number;
  deviceList?: IDeviceConfigurationDictionary[];
  deviceIds?: string[];
  shouldGetDeviceListFromLocal?: boolean;
  cdmAlternateIdSource?: CDMAlternateIdSourceEnumerationType;
  deviceConfigurations?: TouchPointDeviceConfiguration[];
  systemParams?: SystemParameterInfo[];
  paymentCardConfirmationRequired?: boolean;
  productAvailabilityRadiusFromPOS?: number;
  touchPointGroupId?: string;
  passwordRequiredForBarcode?: boolean;
  protectCustomerPersonalInformation?: boolean;
  defaultTemperatureUnitOfMeasure?: string;
  entryTouchPointType?: string;
  generateUsabilityReport?: boolean;
  sscConfiguration?: ISelfScanConfiguration;
  scoConfiguration?: IScoConfiguration;
  /** HH:MM:SS format  */
  idleTime?: string;
  defaultLengthUnitOfMeasure?: string;
  defaultWeightUnitOfMeasurePrecision: number;
  defaultAmountDecimalPrecision: number;
  defaultWeighUnitOfMeasure?: string;
  currencyCode?: string;
  currencySymbol?: string;
  measurementSystemType?: string;
  autoSelectFirstFuelItem?: boolean;
  isCashDrawerFull?: boolean;
  isTaxTotalVisible?: boolean;
  depositConfigurations?: DepositConfigurationType;
  ownBagConfiguration?: IOwnBagConfiguration;
  callGetCardDetailsByTenderType?: boolean;
}

export interface DepositConfigurationType {
  displayDepositItemOnCashierDisplayAndCustomerDisplay?: boolean;
}

export interface IScoConfiguration {
  unattendedWeightTimeout?: number;
  bagWeightTolerance?: number;
  securityScaleDigression?: number;
  itemNotPlaceInBagTimeout?: number;
  notAllQtySaleItemsPlacedInBagTimeout?: number;
  couponNotPutInSensorTimeout?: number;
  numberOfOwnBagThreshold?: number;
  securityScaleValidation?: string;
}

export interface ISelfScanConfiguration {
  availForRegisteredShoppers?: boolean;
  availForNonRegisteredShoppers?: boolean;
}

export enum CDMAlternateIdSourceEnumerationType {
  AlternateIdOnly = 'AlternateIdOnly',
  CommonSearchFields = 'CommonSearchFields',
}

export interface TouchPointDeviceConfiguration {
  deviceConfigurationName?: string;
  isActive?: boolean;
  orderIndex?: number;
}

export interface SystemParameterInfo {
  parameterGroup?: string;
  parameterKey?: string;
  parameterValue?: string;
  storeId?: string;
}

export interface IOwnBagConfiguration {
  ownBagEnabled?: boolean;
  productId?: string;
  methodOfWork?: IOwnBagConfigurationMethodType;
  ownBagLimit?: number;
}

export enum IOwnBagConfigurationMethodType {
  TriggeredOnPayment = 'TriggeredOnPayment',
  TriggeredOnSale = 'TriggeredOnSale',
}
